import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54c1875b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column w-full gap-4 w-full" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-2xl font-semibold" }
const _hoisted_4 = { class: "flex flex-column justify-content-center align-items-center border-1 border-300 border-round-2xl border-dashed p-4 mt-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/routePlanner/add-favourite.svg",
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "text-base text-600 px-6 text-center" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "flex w-full mt-auto justify-content-between align-items-center" }
const _hoisted_9 = { class: "text-2xl font-semibold" }
const _hoisted_10 = { class: "text-600" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex mt-auto align-items-center w-full justify-content-between border-bottom-1 border-gray-400" }
const _hoisted_13 = { class: "flex flex-column gap-1 w-full pb-1" }
const _hoisted_14 = { class: "font-semibold" }
const _hoisted_15 = { class: "text-sm text-500 max-w-fit" }
const _hoisted_16 = { class: "card flex justify-center" }
const _hoisted_17 = { class: "flex align-items-center gap-2 p-2 cursor-pointer" }
const _hoisted_18 = { class: "flex flex-column gap-4" }
const _hoisted_19 = { class: "pb-4" }
const _hoisted_20 = { class: "flex gap-3 justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_IconDotsVertical = _resolveComponent("IconDotsVertical")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_FavouriteDialog = _resolveComponent("FavouriteDialog")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.savedLocations && _ctx.savedLocations.total === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("global.saved")), 1),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("route_planner.add_favourite_description")), 1),
              _createVNode(_component_Button, {
                class: "button secondary",
                label: _ctx.$t('global.add'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isAddressModalOpen = true))
              }, null, 8, ["label"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.savedLocations && _ctx.savedLocations.total > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.$t("global.saved")) + " ", 1),
                _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(_ctx.savedLocations?.total) + ")", 1)
              ]),
              _createVNode(_component_Button, {
                class: "button secondary small",
                label: _ctx.$t('global.add'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isAddressModalOpen = true))
              }, null, 8, ["label"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedLocations?.data, (location, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex mt-4 w-full gap-4 align-items-center pb-1 cursor-pointer",
                key: index,
                onClick: ($event: any) => (_ctx.selectLocation(location))
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getIconComponent(location.icon)), { class: "text-2xl thin-icon" })),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(location.title), 1),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(location.address), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_Button, {
                      type: "button",
                      class: "p-button-text",
                      onClick: _withModifiers((event) => _ctx.showMenu(event, location), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconDotsVertical, { class: "thin-icon text-600" })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ])
              ], 8, _hoisted_11))
            }), 128)),
            _createVNode(_component_Menu, {
              ref: "menu",
              model: _ctx.menuItems,
              popup: true,
              class: "surface-0 shadow-2 px-2 py-2 border-round-lg border-1 border-300"
            }, {
              item: _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "text-base" })),
                  _createElementVNode("span", null, _toDisplayString(item.label), 1)
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showLoadMore)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 2,
            class: "p-button border-none shadow-none hover:bg-transparent focus:ring-0 text-gray-800 -mt-8 w-full h-12rem button-gradient",
            label: _ctx.$t('route_planner.show_more'),
            onClick: _ctx.loadMore
          }, null, 8, ["label", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_FavouriteDialog, {
      visible: _ctx.isAddressModalOpen,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isAddressModalOpen) = $event)),
      onClose: _ctx.closeFavouriteDialog,
      location: _ctx.selectedLocation,
      onRefresh: _ctx.getSavedLocations
    }, null, 8, ["visible", "onClose", "location", "onRefresh"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showDeleteLocationDialog,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showDeleteLocationDialog) = $event)),
      modal: true,
      draggable: false,
      header: _ctx.$t('route_planner.deletion'),
      class: "rounded lg",
      onHide: _ctx.cancelDeletion
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("route_planner.confirm_deletion")), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_Button, {
              class: "button text",
              onClick: _ctx.cancelDeletion
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("global.cancel")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, {
              class: "button primary",
              onClick: _ctx.handleDelete
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("global.delete")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header", "onHide"])
  ], 64))
}